// File: ./src/js/modules/home-slider-featured.js

/**
 * Home Featured Slider
 * Swiper fade slider per: post e CPT → storie e cooperative_blog
 * 
 * Selettore Swiper da recuperare → div con la classe 'swiper-home-featured'
 */

export default function initHomeFeaturedSlider(swiperSelector = ".swiper-home-featured") {
    if (typeof Swiper === "undefined") {
        console.warn("Swiper non disponibile per Home Featured Slider");
        return;
    }

    const sliders = document.querySelectorAll(swiperSelector);
    if (sliders.length === 0) {
        console.info("Nessun Home Featured Slider trovato");
        return;
    }

    sliders.forEach((slider, index) => {
        const slides = slider.querySelectorAll(".swiper-slide");
        const enableLoop = slides.length > 1;

        new Swiper(slider, {
            spaceBetween: 0,
            loop: enableLoop,
            speed: 1000,

            autoplay: {
                delay: 5000,
                disableOnInteraction: false,
                pauseOnMouseEnter: true,
            },

            effect: "fade",
            fadeEffect: {
                crossFade: true,
            },

            pagination: {
                el: slider.querySelector(".home-slider__pagination"),
                clickable: true,
            },
        });

        console.log(`👍 Home Featured Slider inizializzato #${index + 1}`);
    });
}
